'use client';

import styled from 'styled-components';

import { colors } from '@/styles/theme';

export const Container = styled.div`
  display: flex;
  align-items: center;

  color: ${({ $color }) => colors[$color] || 'inherit'};
`;
